<app-modal-selector></app-modal-selector>
<router-outlet></router-outlet>
<!-- <button
  (click)="themeSwitcher()"
  class="fixed bottom-20 right-4 p-2 text-mainTextLight dark:text-mainText cursor-pointer">
  Switch
</button> -->
<span id="chatButton" class="hidden">CHAT</span>
